import { useNavigation, useRouter } from 'expo-router';
import { StackActions } from 'expo-router/react-navigation';
import { RDCContext } from 'features/rdc/providers/RDCContextProvider/RDCContextProvider';
import { useContext } from 'react';

export type RDCNavigator = {
  restart: () => void;
  finish: () => void;
};

const isMoveMoneyRoot = (name: string) => {
  return (
    name === 'move-money/check-deposit/index' ||
    name === 'move-money/check-deposit'
  );
};

const useRDCNavigator = (): RDCNavigator => {
  const { clear } = useContext(RDCContext);
  const navigation = useNavigation();
  const router = useRouter();

  return {
    restart: () => {
      clear();
      // the rdc flow should always start by pushing `/move-money/check-deposit`
      // onto the stack so this call should effectively return to the start of the flow
      // in the event this is not in the stack, this will push a new instance of
      // this screen, this is an unexpected scenario.
      router.dismissTo('/move-money/check-deposit');
    },
    finish: () => {
      clear();
      const state = navigation.getState();
      if (!state) {
        // handle the case where state is undefined
        router.navigate('/move-money');
        return;
      }
      const { routes } = state;
      const checkDepositLaunch = routes.findIndex((element) => {
        const { name } = element;
        // for some reason name is typed as never here...
        if (typeof name === 'string') {
          return isMoveMoneyRoot(name);
        }
      });

      if (checkDepositLaunch < 1) {
        router.back();
        return;
      }
      // else navigate back to the entry point
      navigation.dispatch(StackActions.pop(routes.length - checkDepositLaunch));
    },
  };
};

export default useRDCNavigator;
